import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Hero from '../../components/Hero/Hero';
import ExpandingVideo from '../../components/ExpandingVideo/ExpandingVideo';
import Features from '../../components/Features/Features';
import Testimonials from '../../components/Testimonials/Testimonials';
import Pricing from '../../components/Pricing/Pricing';
import CTA from '../../components/CTA/CTA';
import Footer from '../../components/Footer/Footer';
import './Landing.css';

export default function Landing() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const targetId = hash.replace('#', '');
      const element = document.getElementById(targetId);
      if (element) {
        // Small timeout to ensure DOM is ready
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 300);
      }
    }
  }, [hash]);

  return (
    <div className="landing">
      <Navbar />
      <main>
        <Hero />
        <ExpandingVideo />
        <Features />
        <Testimonials />
        <Pricing />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

